'use strict';

function EmailToTaskCtrl(
  $scope,
  $translate,
  groups,
  taskTypes,
  CompanyUserService,
  $stateParams) {
  $scope.groups = groups;
  $scope.importanceColors = [
    {
      'type': 'LOW',
      'color': '#27b96b'
    },
    {
      'type': 'NORMAL',
      'color': '#27c2eb'
    },
    {
      'type': 'HIGH',
      'color': '#f29a25'
    }
  ];

  $scope.visibilityColors = [
    {
      'public': true,
      'color': '#23a45f'
    },
    {
      'public': false,
      'color': '#27c2eb'
    },
  ];

  $scope.taskTypes = taskTypes;

  var nonWatchersPromise;
  $scope.nonWatchers             = [];
  $scope.updateNonWatchers = function(filter, watchers) {   
    var p = CompanyUserService.query({
        companyId: $stateParams.companyId,
        q: filter,
        limit: 10}).$promise.then(function(users) {
      return users.filter(function(item) {
        return !watchers.some(function(watcher) {
          return item.id === watcher.id;
        });
      });
    }).then(function(nonWatchers) {
      if(nonWatchersPromise === p) {
        $scope.nonWatchers = nonWatchers;
      }
    });
    
    nonWatchersPromise = p;
  };

  $scope.addWatcher = function(item, watchers) {
    watchers.push(item);
    $scope.nonWatchers.splice($scope.nonWatchers.indexOf(item), 1);
  };
}

EmailToTaskCtrl.resolve = {
  groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
    return CompanyGroupService.query({
      companyId: $stateParams.companyId,
      all: true
    }).$promise;
  }],
  taskTypes: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.queryTaskTypes({companyId: $stateParams.companyId}).$promise;
  }]
};

module.exports = EmailToTaskCtrl; 
angular.module('dokiv')
  .controller('EmailToTaskCtrl', [
    '$scope',
    '$translate',
    'groups',
    'taskTypes',
    'CompanyUserService',
    '$stateParams',
    EmailToTaskCtrl]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-task/EmailToTaskCtrl.js
// module id = 346
// module chunks = 0